export const templates = [{id: 1, templateName: "Rent"}];